<template>
  <div id="ImageUpload">
    <p
      v-if="question.sub_text_html"
      v-html="decodeData(question.sub_text_html)"
      class="sub-text"
    ></p>

    <label for="image-file" class="label">
      <span>Upload Images</span>
      <i class="fa fa-plus" aria-hidden="true"></i>
    </label>
    <input
      id="image-file"
      type="file"
      class="input"
      :accept="fileExtensions.join(',')"
      @change="handleFiles"
      multiple
    />
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

    <div class="preview-container" v-if="previewImages && previewImages.length">
      <div v-for="(image, index) in previewImages" :key="index">
        <div
          v-if="image.question_id === question.question_id"
          class="image-preview"
        >
          <img class="image" :src="image.src" :alt="'Preview ' + (index + 1)" />
          <button class="remove-button" @click="removeImage(index, image.name)">
            Remove Photo
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageUpload",
  props: [
    "setAnswer",
    "answer",
    "question",
    "previewImages",
    "originalFiles",
    "removeImage"
  ],
  data() {
    return {
      errorMessage: ""
    };
  },
  computed: {
    validation() {
      return this.question?.validation;
    },
    fileExtensions() {
      return (
        this.validation?.file_extensions.map(ext => `.${ext.toLowerCase()}`) || []
      );
    },
    sizeLimitNumber() {
      return this.validation.max_file_size_mb;
    }
  },
  mounted() {
    const fileNames = this.previewImages.map(file => {
      return file.name;
    });
    this.setAnswer(fileNames);
  },
  methods: {
    decodeData(data) {
      try {
        return atob(data);
      } catch (error) {
        return data;
      }
    },
    handleFiles(event) {
      const files = Array.from(event.target.files);
      this.errorMessage = "";

      const allowedExtensions = this.validation.file_extensions.map(ext =>
        ext.toLowerCase()
      );

      files.forEach(file => {
        const fileExtension = file.name
          .split(".")
          .pop()
          .toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
          this.errorMessage = `File type not allowed: ${file.name}`;
          return;
        }

        const sizeInMB = file.size / (1024 * 1024);
        if (sizeInMB > this.sizeLimitNumber) {
          this.errorMessage = `File "${file.name}" is too large (max ${this.sizeLimitNumber}MB).`;
          return;
        }

        const reader = new FileReader();
        reader.onload = e => {
          this.previewImages.push({
            src: e.target.result,
            name: file.name,
            size: `${sizeInMB.toFixed(2)} MB`,
            question_id: this.question.question_id
          });
          this.originalFiles.push(file);

          const fileNames = this.previewImages.map(file => file.name);
          this.setAnswer(fileNames);
        };
        reader.readAsDataURL(file);
      });

      event.target.value = "";
    }
  }
};
</script>

<style lang="less">
#ImageUpload {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .label {
    cursor: pointer;
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: rgba(30, 30, 34, 0.05);
    padding: 16px;
    border-radius: 5px;
    color: #1e1e22;
    font-size: 1.4rem;
    font-family: "DMSans Bold";

    .fa {
      font-size: 2rem;
    }
  }

  .input {
    visibility: hidden;
  }

  .preview-container {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
  }

  .image-preview {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-top: 20px;
  }

  .image {
    width: 138px;
    height: auto;
    object-fit: contain;
    margin-bottom: 12px;
  }

  .remove-button {
    font-size: 1.6rem;
    font-family: "DMSans Bold";
    border-radius: 12px;
    border: 1px solid #fd3d3d;
    padding: 16px 20px;
    background-color: #fff;
    color: #fd3d3d;
    margin: 0;
  }

  .error-message {
    color: #fd3d3d;
    font-size: 1.6rem;
    font-family: "DMSans";
  }

  .sub-text {
    width: 100%;
    h3 {
      font-size: 2.2rem;
      letter-spacing: 0;
      color: #1e1e22;
      font-family: "DMSans Bold";
      padding: 0;
      margin: 0 0 32px 0;
    }

    p {
      color: #1e1e22;
      font-size: 1.8rem;
      margin-bottom: 24px;
    }
  }
}
</style>
